<template>
  <div class='port-issue-body'>
    <div class='description-block' :style="`flex-wrap: ${isShowAll ? 'wrap' : 'nowrap'};`">
      <div class='data-title'>{{ $t('detailed.issue.description.title') }}</div>
      <div class='text-container description' :class='{closed: !isShowAll}'>
        {{ collapsedDescriptionForPort }}
      </div>
      <span class='hide-technologies-btn' @click.stop="isShowAll = !isShowAll" v-if="collapsedDescriptionForPort !== 'N/a'">
          {{ captionOfTechnologiesToggleButton }}
      </span>
    </div>
    <div class='asset-block'>
      <div class='data-title'>{{ $t('detailed.issue.asset.title') }}</div>
      <div class='text-container'>
        {{ asset }}
      </div>
    </div>
    <div class='asset-block'>
      <div class='data-title'>{{ $t('detailed.issue.port.title') }}</div>
      <div class='text-container'>
        {{ port }}
      </div>
    </div>
    <div class='tld-block'>
      <div class='details-column'>
        <div class='data-title'>{{ $t('detailed.issue.tld.title') }}</div>
        <div class='text-container'>
          {{ tld }}
        </div>
      </div>
      <div class='details-column' v-if='isDeepScan'>
        <div class='data-title'>{{ $t('detailed.issue.subdomain.title') }}</div>
        <div class='text-container'>
          {{ subdomain }}
        </div>
      </div>
    </div>
    <div class="technical-block" v-if="portUrl">
      <div class="data-title">{{$t('issueDataPopup.technical.data')}}</div>
      <div class="technical-data">
        <div class='text-container'>
          <div class='details-column technical-data'>
            <div class="data-sub-title">{{$t('issueDataPopup.url')}}</div>
            <div class='text-container cve-url' :title='portUrl'>
              <a :href='portUrl' target="_blank"> {{portUrl}} </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TEST_TYPES_HOSTS } from '@/constants/projects';
import {IssueTypeNames} from '@/components/CentralizedIssues/CentralizedIssuesDataView.vue';

export default {
  name: 'PortIssueBody',
  props: {
    issue: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      isShowAll: false,
    };
  },
  computed: {
    tld() {
      return this.issue.tld || '';
    },
    subdomain() {
      return this.issue.metaData?.subdomain || '';
    },
    asset() {
      return this.issue.asset || '';
    },
    metaData() {
      return this.issue.metaData || {};
    },
    description() {
      return this.issue.metaData.description || '';
    },
    portUrl() {
      return this.issue.metaData.portUrl || '';
    },
    port() {
      if (this.issue.name === IssueTypeNames.cloudDiscovery) {
        return this.issue.displayName.split('Exposed Port Found On Cloud Instance ')[1] || this.issue.displayName.split('Exposed Port ')[1].split(' Found On Cloud Instance')[0];
      }
      return this.issue.displayName.split('Exposed Port Found ')[1] || this.issue.displayName.split('Exposed Port ')[1].split(' Found')[0];
    },
    collapsedDescriptionForPort() {
      return this.issue.metaData.description || 'N/a';
    },
    captionOfTechnologiesToggleButton() {
      return this.isShowAll ? this.$t('detailed.issue.show.less.list') : this.$t('detailed.issue.show.more.list');
    },
    isDeepScan() {
      return this.issue.metaData.testSource === TEST_TYPES_HOSTS.deepscan && this.subdomain !== '';
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.port-issue-body {
  .details-column {
    display: inline-block;
    width: fit-content;
    max-width: rem(650);
    margin-right: $space-4;
  }
  .description-block {
    display: block;
    width: rem(650);
    .text-container::first-letter {
      text-transform: capitalize;
    }

    .text-container {
      padding-right: rem(60);
      font-size: $font-size-base;
      letter-spacing: 0;
      line-height: rem(18);
      &.closed {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3;
        line-height: 1.2em;
      }
    }
  }
  .technical-block {
    padding-bottom: $space-5;
    display: block;
    .technical-data {
      padding-top: rem(4);
      .url {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .data-title {
    color: var(--text-secondary);
    font-size: $font-size-sm;
    letter-spacing: rem(0.8);
    line-height: $font-size-xs;
    text-transform: uppercase;
    margin-bottom: $space-1;
  }
  .data-sub-title {
    font-size: $font-size-xs;
    color: var(--text-secondary);
    letter-spacing: rem(0.8);
    line-height: $font-size-xs;
    text-transform: uppercase;
    margin-bottom: $space-1;
  }
  .asset-block {
    margin-bottom: $space-5;
    margin-top: $space-4;
  }
  .tld-block {
    margin-bottom: $space-5;
  }
  .subdomain-block {
    margin-bottom: $space-5;
  }
  .hide-technologies-btn {
    color: var(--link-primary);
    font-family: $font-family-regular;
    font-size: $font-size-base;
    letter-spacing: 0;
    &:hover {
      cursor: pointer;
    }
  }
  .description {
    white-space: pre-line;
  }
}
</style>
